/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const SupportRequestAdminUpdateDTOStatusEnum = {
    Pending: 'PENDING',
    Planned: 'PLANNED',
    Finished: 'FINISHED'
};
/**
 * Check if a given object implements the SupportRequestAdminUpdateDTO interface.
 */
export function instanceOfSupportRequestAdminUpdateDTO(value) {
    return true;
}
export function SupportRequestAdminUpdateDTOFromJSON(json) {
    return SupportRequestAdminUpdateDTOFromJSONTyped(json, false);
}
export function SupportRequestAdminUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'adminResponse': json['adminResponse'] == null ? undefined : json['adminResponse'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}
export function SupportRequestAdminUpdateDTOToJSON(json) {
    return SupportRequestAdminUpdateDTOToJSONTyped(json, false);
}
export function SupportRequestAdminUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'adminResponse': value['adminResponse'],
        'status': value['status'],
    };
}
